export const environment = {
  version: '2.3.8',
  production: true,
  apiURL: 'https://gandalf-uat.lndr.credit/',
  finduis: 'https://finduistest.lnder.co.za/fineract-provider/api/v1/'
};
